import { render, staticRenderFns } from "./DynamicDivisionType.vue?vue&type=template&id=bb14bc76"
import script from "./DynamicDivisionType.vue?vue&type=script&lang=js"
export * from "./DynamicDivisionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb14bc76')) {
      api.createRecord('bb14bc76', component.options)
    } else {
      api.reload('bb14bc76', component.options)
    }
    module.hot.accept("./DynamicDivisionType.vue?vue&type=template&id=bb14bc76", function () {
      api.rerender('bb14bc76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/DynamicDivisionType.vue"
export default component.exports